import React, {VoidFunctionComponent} from 'react';

import Chip from '../chip/chip';

import {useFilters} from '../../../hooks/useFilters';
import useTags from '../../../hooks/useTags';

import {Tag, TagsList} from '../../../../../shared/types/work';

interface Props {
  tags: TagsList | null;
  isFilter?: boolean;
}

const Tags: VoidFunctionComponent<Props> = props => {
  const {tags, isFilter} = props;
  const {selectedTagFilterOptions, setSelectedTags} = useFilters();
  const {tagsFilterEntries} = useTags();

  // Handle tag click
  const handleClick = (tag: Tag) => {
    // Find the selected tag in the tag filter entries
    const selectedTag = tagsFilterEntries?.find(tagFilterEntry => {
      if (tagFilterEntry.label.includes(tag)) {
        return tagFilterEntry;
      }

      return null;
    });

    // Select tag
    if (selectedTag) {
      setSelectedTags(selectedTag);
    }
  };

  return (
    <div>
      {tags?.map(
        tag =>
          tag && (
            <Chip
              key={tag}
              title={tag}
              isActive={Boolean(
                selectedTagFilterOptions.find(
                  currentFilterTag => currentFilterTag.label === tag
                )
              )}
              isFilter={isFilter}
              onClick={() => handleClick(tag)}
            />
          )
      )}
    </div>
  );
};

export default Tags;
